import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from '../common.service';
@Component({
  selector: 'app-viewusermanagement',
  templateUrl: './viewusermanagement.component.html',
  styleUrls: ['./viewusermanagement.component.css']
})
export class ViewusermanagementComponent implements OnInit {
  returnUrl= "/dashboard/usermanagement";
  getuserviewApi:any;
  getval:any;
  getfarmvalue:any;
  getdepartmentvalue:any
  constructor(private router: Router,private commonService: CommonService) { }

  async ngOnInit() {
    let UserId = sessionStorage.getItem('userId');
    this.getuserviewApi= "/user_management/"+UserId;
    (await this.commonService.getApi(this.getuserviewApi)).subscribe(
      res => { 
             this.getdepartmentvalue=res.data.tnus_department
             this.getfarmvalue=res.data.farm_name
        $("#username").text(res.data.tnus_name),
       $("#userid").text(res.data.tnus_user_code),
       $("#useremail").text(res.data.tnus_email),
       $("#contactno").text(res.data.tnus_contact_no),
      // $("#department").text(res.data.tnus_department),
      // $("#Status").text(res.data.tnus_status),
     this.getval=res.data.tnus_status;
        if (this.getval==1) 
{
  $("#Status").text("Active").addClass("green");
}
if (this.getval==0) {
 $("#Status").text("InActive").addClass("red");
} ;
  if(res.data.tnus_role==('Farm user')){
  $("#userrole").text("Farm User")
}else{
  $("#userrole").text(res.data.tnus_role)
}
      
      })
  }
  usermanagement(){
    this.router.navigate([this.returnUrl]);
  }
  backnavigate(){
    this.router.navigate([this.returnUrl]);
  }



}
